var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLineBoringDrill(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M426.73 270.26L353 196.53v-22.62c0-31.56-25.7-57.27-57.27-57.27h-22.62L241.75 64H180.4l-31.56 31.56H128c-31.56 0-57.27 25.7-57.27 57.27v22.62l-73.73 73.73C13.57 285.12 0 311.58 0 340.16v82.94C0 473.3 38.7 512 86.28 512h339.44c47.58 0 86.28-38.7 86.28-86.28v-82.94c0-28.58-13.57-55.04-36.27-70.92zM82.96 196.53c0-18.11 14.73-32.84 32.84-32.84h22.62l31.56-31.56h61.35l31.56 31.56h22.62c18.11 0 32.84 14.73 32.84 32.84v22.62L114.58 270.26l-31.62-31.62-.03-11.51zm166.23 114.56c-15.67 0-28.39-12.71-28.39-28.39s12.71-28.39 28.39-28.39 28.39 12.71 28.39 28.39-12.71 28.39-28.39 28.39z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineBoringDrill);
export default __webpack_public_path__ + "static/media/line-boring-drill.9a3a04991a1c67725072e7aeeeb938a8.svg";
export { ForwardRef as ReactComponent };